import type { VehicleBlueprint } from "../types/VehicleBlueprint.js";
import type { CarStats } from "./CarStats.js";

/**
 * Converts a VehicleBlueprint into a base CarStats with no upgrades or damage.
 *
 * Migration invariant: computeStats(bp, DEFAULT_UPGRADES, {}) must return
 * values identical to the original blueprint handling fields.
 *
 * Fields with no blueprint equivalent (gearShiftSpeed, boostPower, downforce)
 * use constants that reproduce the physics previously hardcoded in
 * VehicleController:
 *   - downforce 0.4 → grip loss = 1 - 0.4 = 0.6  (was hardcoded 0.6)
 *   - boostPower 1.0 → full existing boost constants
 *   - gearShiftSpeed 1.0 → unmodified EngineAudio gear thresholds
 */
export function blueprintToBaseStats(bp: VehicleBlueprint): CarStats {
  return {
    topSpeed:      bp.handling.maxSpeed,
    accel:         bp.handling.acceleration,
    brakeForce:    bp.handling.braking,
    traction:      bp.handling.traction,
    drift:         bp.handling.drift,
    turnRate:      bp.handling.turnRate,
    mass:          bp.stats.mass,
    boostPower:    1.0,
    downforce:     0.4,
    gearShiftSpeed: 1.0,
  };
}
